import * as React from "react";
import { SessionNote, EcgAnalysisSetTest } from "webportalclient";
import { InterpretationsSelector } from "./InterpretationsSelector";
import { TestFixedCommentsState, ToggleAlertFixedCommentsVisibilityAction, ToggleTestFixedCommentsVisibilityAction } from "./UseFixedComments";
import { AsyncActionButton } from "../misc/components/AsyncActionButton";
import { EcgAnalysisSetTypeEnum } from "../misc/api/ApiEcgAnalysisSetType";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface EcgDashboardProps {
    test: EcgAnalysisSetTest;
    isAnalysis: boolean;
    canEdit: boolean;
    notes: SessionNote[];
    fixedCommentsState: any;
    fixedCommentsDispatch: any;
    setNotesVisible: (visible: boolean) => void;
    isSubmittingAccept: boolean;
    isSubmittingReject: boolean;
    canViewNotes: boolean;
    canAddNotes: boolean;
    onComplete: () => void;
    onReview: (accepted: boolean) => void;
    setGlasgowStatementsVisible: (visible: boolean) => void;
}

export const SelectedCommentsCount = (fixedComments: TestFixedCommentsState[]) => fixedComments.map(x => ({
    id: x.id,
    count: x.comments.filter(x => x.selected).length
}));

export const EcgDashboard = ({ test, isAnalysis, canEdit, notes, fixedCommentsState, fixedCommentsDispatch, setNotesVisible, isSubmittingAccept, isSubmittingReject, canViewNotes, canAddNotes, onComplete, onReview, setGlasgowStatementsVisible }: EcgDashboardProps) => {
    return (
        <>
            <div className="panel">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-6">
                            <InterpretationsSelector
                                testId={test.testId}
                                selectedInterpretationsCount={SelectedCommentsCount(fixedCommentsState.testFixedComments)}
                                onInterpretationClick={() => fixedCommentsDispatch(ToggleTestFixedCommentsVisibilityAction.create(test.testId))}
                                selectedAlertsCount={SelectedCommentsCount(fixedCommentsState.alertFixedComments)}
                                onAlertClick={() => fixedCommentsDispatch(ToggleAlertFixedCommentsVisibilityAction.create(test.testId))}
                            />&nbsp;
                            {canViewNotes ? <><button disabled={test.analysisSet.type === EcgAnalysisSetTypeEnum.QC} className="btn btn-primary" onClick={() => setNotesVisible(true)} data-automationid="NotesButton">
                                Notes&nbsp;
                                <span className="badge badge-info">{notes.length}</span>
                            </button>&nbsp;</>: null}
                            <button className="btn btn-primary btn-outline" onClick={() => setGlasgowStatementsVisible(true)} data-automationid="GlasgowStatementsButton">Glasgow Statements</button>
                        </div>
                        <div className="col-md-6">
                            <div className="pull-right">
                                {isAnalysis ?
                                    (canEdit ? <EcgAnalysisButtons isSubmitting={isSubmittingAccept} onComplete={onComplete} /> : null)
                                    : <EcgReviewButtons isSubmittingAgree={isSubmittingAccept} isSubmittingDisagree={isSubmittingReject} onAcceptOrReject={onReview} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

interface EcgAnalysisButtonsProps {
    isSubmitting: boolean;
    onComplete: () => void;
}

export const EcgAnalysisButtons = ({ isSubmitting, onComplete }: EcgAnalysisButtonsProps) => {
    return (<AsyncActionButton id="CompleteButton" isSubmitting={isSubmitting} className="btn btn-success" disabled={isSubmitting} onClick={() => onComplete()}>
        <FontAwesomeIcon icon={faCheck} aria-hidden="true" /> Complete Analysis
    </AsyncActionButton>);
}

interface EcgReviewButtonsProps {
    isSubmittingAgree: boolean;
    isSubmittingDisagree: boolean;
    onAcceptOrReject: (acceptable: boolean) => void;
}

export const EcgReviewButtons = ({ isSubmittingAgree, isSubmittingDisagree, onAcceptOrReject }: EcgReviewButtonsProps) => {
    return (
        <>
            <AsyncActionButton id="AgreeButton" isSubmitting={isSubmittingAgree} className="btn btn-success" disabled={isSubmittingAgree || isSubmittingDisagree} onClick={() => onAcceptOrReject(true)}>
                <FontAwesomeIcon icon={faCheck} aria-hidden="true" /> Agree
            </AsyncActionButton> &nbsp;
            <AsyncActionButton id="DisagreeButton" isSubmitting={isSubmittingDisagree} className="btn btn-danger" disabled={isSubmittingAgree || isSubmittingDisagree} onClick={() => onAcceptOrReject(false)}>
                <FontAwesomeIcon icon={faXmark} aria-hidden="true" />Disagree
            </AsyncActionButton>
        </>
    )
}
